import React, { Fragment, useState, useEffect } from "react";
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
import { CardBody, Button, Card, CustomInput, Input, Label, Row, ButtonGroup } from "reactstrap";
import { Colxx, Separator } from "../../../../../../components/common/CustomBootstrap";
const StandaloneSocialSharing = ({ pageSettings, saveIntegration, country, }) => {        
    const [data, setData] = useState((pageSettings !== undefined && pageSettings.socialSharing !== undefined) ? pageSettings.socialSharing : {
        showFacebook: false,
        showTwitter: false,
        showLinkdin: false,
        facebookLink: '',
        twitterLink: '',
        linkdinLink: '',
        isEnable: false,        
    }); 

    const handleSave = () => {
        pageSettings.socialSharing = data;
        saveIntegration({ pageSettings: pageSettings });
    };


    return (
        <Fragment>
            <Card className="mb-4">
                <CardBody className="mb-2">
                <div className="col-md-12 text-center my-3">
                  <h4> Social Sharing</h4>
                  <p className="ml-2 my-2">
                    Let your customers spread the word
                  </p>
                </div>
                <Separator className="mb-3" />
                    <div className="col-md-12 my-2">
                        <div className="mb-1 ml-2 d-flex">
                            <h4>Enable</h4>
                            <div className="ml-2">
                                <Switch
                                    className="custom-switch custom-switch-primary custom-switch-small "
                                    checked={data.isEnable}
                                    onChange={(primary) => setData({ ...data, isEnable: primary })}
                                />
                            </div>
                            </div>
                            <div className="col-md-12 my-3">
                            <p className="m-2">Select the social platform to enable social sharing icons on your Vouchers and Gift Cards</p>
                        </div>
                    
                    </div>                    
                    <div className="col-md-12 my-2">
                        <Row className="mt-2">
                            <Colxx xxs="4">
                                <CustomInput
                                    key="Facebook"
                                    type="checkbox"
                                    id="Facebook"
                                    onChange={(e) => setData({ ...data, showFacebook: e.target.checked })}
                                    checked={data.showFacebook}
                                    className="text-left"
                                >
                                    Facebook
                                </CustomInput>
                            </Colxx>
                        </Row>
                        <Row className="mt-2 ml-4">
                            <Input
                                type="text"
                                style={{ width: '50%' }}
                                value={data.facebookLink}
                                name="type"
                                onChange={(e) => setData({ ...data, facebookLink: e.target.value })}
                            >

                            </Input>
                        </Row>
                    </div>
                    <div className="col-md-12 my-2">
                        <Row className="mt-2">
                            <Colxx xxs="4">
                                <CustomInput
                                    key="Facebook"
                                    type="checkbox"
                                    id="Facebook"
                                    onChange={(e) => setData({ ...data, showTwitter: e.target.checked })}
                                    checked={data.showTwitter}
                                    className="text-left"
                                >
                                    Twitter
                                </CustomInput>
                            </Colxx>
                        </Row>
                        <Row className="mt-2 ml-4">
                            <Input
                                type="text"
                                style={{ width: '50%' }}
                                value={data.twitterLink}
                                name="type"
                                onChange={(e) => setData({ ...data, twitterLink: e.target.value })}
                            >

                            </Input>
                        </Row>
                    </div>
                    <div className="col-md-12 my-2">
                        <Row className="mt-2">
                            <Colxx xxs="4">
                                <CustomInput
                                    key="Facebook"
                                    type="checkbox"
                                    id="Facebook"
                                    onChange={(e) => setData({ ...data, showLinkdin: e.target.checked })}
                                    checked={data.showLinkdin}                                    
                                    className="text-left"
                                >
                                    Linkedin
                                </CustomInput>
                            </Colxx>
                        </Row>
                        <Row className="mt-2 ml-4">
                            <Input
                                type="text"
                                style={{ width: '50%' }}
                                value={data.linkdinLink}
                                name="type"
                                onChange={(e) => setData({ ...data, linkdinLink: e.target.value })}
                            >

                            </Input>
                        </Row>
                    </div>
                     
                    <div className="text-center mt-4 mb-3">
                        <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
                            <Button color="primary" size="xs" outline onClick={handleSave}>
                                Save
                            </Button>
                        </ButtonGroup>
                    </div>
                </CardBody>
            </Card >
        </Fragment >
    );
}
export default StandaloneSocialSharing;
